<script setup>
  import { ref, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import MatchingJobSystemView from './MatchingJobSystemView.vue'
  import MatchingJobJobPostingsView from './MatchingJobJobPostingsView.vue'
  import MatchingJobTalentView from './MatchingJobTalentView.vue'
  import MatchingJobCompanyView from './MatchingJobCompanyView.vue'

  const route = useRoute();
  const router = useRouter();
  const tabRef = ref(null);

  const tabOptions = [
    { label: 'KDA 채용지원시스템', value: 'system' },
    { label: '채용공고', value: 'job-postings' },
    { label: '인재정보', value: 'talent' },
    { label: '기업소개', value: 'company' },
  ];

  const selectedTabValue = ref(tabOptions[0].value);

  const onChangeTab = (tab) => {
    selectedTabValue.value = tab.value;
    router.push({ query: { tab: tab.value } });
  };

  onMounted(() => {
    const tabFromQuery = route.query.tab;
    if (tabFromQuery && tabOptions.some(option => option.value === tabFromQuery)) {
      selectedTabValue.value = tabFromQuery;

      if(tabRef.value) {
        tabRef.value.init(tabFromQuery);
      }
    }
  });
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="title page-title">
        <h3>상시채용관</h3>
      </div>
      <div class="tab-wrap">
        <KSATab 
          ref="tabRef"
          :options="tabOptions" 
          @change="onChangeTab" 
          style="grid-template-columns: repeat(4, 1fr);" 
        />
      </div>

      <div v-if="selectedTabValue === 'system'">
        <MatchingJobSystemView />
      </div>
      <div v-else-if="selectedTabValue === 'job-postings'">
        <MatchingJobJobPostingsView />
      </div>
      <div v-else-if="selectedTabValue === 'talent'">
        <MatchingJobTalentView />
      </div>
      <div v-else-if="selectedTabValue === 'company'">
        <MatchingJobCompanyView />
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
.container {
  overflow: hidden;
}

/* 모바일 진행시 적용할 것
@media (max-width: 639px) {
  .btn-box {
    width:auto;
    padding:0;
  }
}
 */

 
.clickable {
  text-decoration: underline;
  cursor: pointer;
}
.file, .blue {
  color: $blue_color !important;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    &.badge {
      position: relative;
      top: -4px;
    }
  }
}

.btn {
  min-height: 48px;
  height: fit-content;
  border:none;
  cursor:pointer;
  border-radius: 4px;
  padding: 10px 20px;
  background: $blue_color;
  @include font-size_sm;
  color: #fff;
  &.sm_btn {
    height: 30px;
    padding: 1px 10px;
  }
  &.black_button {
    background: $black_color;
    color: #fff;
  }
  &:disabled {
    cursor: default !important;
    background: $gray-light_color !important;
    color: $gray-regular_color !important;
  }
  small {
    display: block;
    line-height: normal;
  }
}
</style>
